import { Reveal } from "@/components/Reveal";
import { Search, MessagesSquare, ClipboardList } from "lucide-react";

const STEPS = [
  {
    icon: Search,
    tag: "Step 01",
    title: "Screen",
    text: "We identify students who need support — quietly and quickly, up to 10 per visit, with teacher input and parent consent.",
  },
  {
    icon: MessagesSquare,
    tag: "Step 02",
    title: "Support",
    text: "Individualised therapy plans delivered by trained therapists, right inside your school — group sessions or one-to-one.",
  },
  {
    icon: ClipboardList,
    tag: "Step 03",
    title: "Report",
    text: "Clear progress reports for parents and management. You see what is changing, month by month.",
  },
];

export const Model = () => (
  <section id="model" className="mx-auto max-w-7xl px-5 py-24 sm:px-8 lg:py-32">
    <Reveal>
      <p className="mb-4 font-mono text-xs font-medium uppercase tracking-[0.28em] text-pine-700">Our signature model</p>
      <h2 className="max-w-2xl font-serif text-2xl font-semibold tracking-tight text-pine-950 sm:text-3xl lg:text-4xl">
        Screen. Support. Report.
      </h2>
      <p className="mt-5 max-w-xl text-sm leading-relaxed text-stone-600 sm:text-base">
        A complete in-school speech and language programme — from first
        screening to measurable progress — without adding work to your staff.
      </p>
    </Reveal>

    <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-3">
      {STEPS.map((s, i) => (
        <Reveal key={s.title} delay={i * 0.1}>
          <div
            data-testid={`model-card-${s.title.toLowerCase()}`}
            className="group flex h-full flex-col rounded-3xl border border-pine-900/10 bg-white p-8 transition-[transform,box-shadow,border-color] duration-500 hover:-translate-y-1.5 hover:border-honey hover:shadow-xl sm:p-10"
          >
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-honey/25 text-pine-900 transition-colors duration-300 group-hover:bg-honey/50">
              <s.icon size={20} />
            </span>
            <p className="mt-7 font-mono text-[10px] uppercase tracking-[0.25em] text-clay">{s.tag}</p>
            <h3 className="mt-2 font-serif text-xl font-semibold text-pine-950 sm:text-2xl">{s.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-stone-600">{s.text}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
